<template>
  <div class="my-header-component">
    <router-link class="my-settings"
                 :to="headerLink"
    >
      <div v-if="isLogin"
           class="info"
      >
        <div class="user">
          <div class="user-avatar">
            <ym-img class="avatar-img"
                    :src="avatar"
                    radius="50%"
                    :alt="name"
                    :lazy="true"
            />
          </div>
          <div class="user-info">
            <h1 class="name ym-line-ellipsis">{{ name }}</h1>
            <div v-if="showPointEntrance"
                 class="point-entrance"
                 v-ym-report:POINTS_ENTRY_CLICK=""
                 @click.stop.prevent="handleClickPointCenter"
            >
              <ym-img class="point-icon"
                      :src="require('@/assets/img/user_center/point_my_icon.png')"
              />
              <div class="point-line">
                <span>{{ pointEntranceText }}</span>
                <ym-icon class="icon-right"
                         name="you"
                         size="8"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="edit">
          <span>编辑资料</span>
          <ym-icon class="icon-right"
                   name="right"
          />
        </div>
      </div>
      <div v-else
           class="login"
      >
        <span class="login-btn">登录/注册</span>
        <span class="login-desc">立即登录享更多特权</span>
      </div>
    </router-link>
  </div>
</template>

<script>
  import { projectJump } from '@/utils';

  export default {
    name: 'MyHeaderNew',
    props: {
      auth: {
        type: String,
      },
      avatar: {
        type: String,
      },
      name: {
        type: String,
      },
      showPointEntrance: {
        type: Boolean,
        default: false,
      },
      myPoint: {
        type: Number,
        default: 0,
      },
      pointStatus: {
        type: String,
        default: 'lock',
      },
    },
    computed: {
      headerLink() {
        const { fullPath } = this.$route;
        return this.auth === ''
          ? { name: 'Login', query: { redirectTo: fullPath } }
          : { name: 'MySetting' };
      },
      isLogin() {
        return this.auth && this.auth !== '';
      },
      pointEntranceText() {
        const { pointStatus, myPoint } = this;
        if (pointStatus === 'lock') return '积分中心';
        return `积分 ${myPoint}`;
      },
    },
    methods: {
      handleClickPointCenter() {
        projectJump({ name: 'PointCenter' });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .my-header-component {
    .my-settings {
      background: url('~@/assets/img/user_center/head_bg.png') no-repeat;
      background-size: 100% 100%;
      height: 440px;
      display: flex;
      justify-content: center;
      padding-top: 80px;
      box-sizing: border-box;
      .login {
        display: flex;
        flex-direction: column;
        .login-btn {
          width: 242px;
          height: 70px;
          margin-bottom: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: @color-primary-aide;
          font-size: @font-size-large;
          font-weight: @font-weight-bold;
          background-color: @color-white;
          border-radius: 18px;
        }
        .login-desc {
          color: @color-white;
          font-size: 26px;
        }
      }
      .info {
        width: 100%;
        height: 120px;
        display: flex;
        justify-content: space-between;
        padding-left: 60px;
        padding-right: 40px;
        .user {
          height: 120px;
          display: flex;
          align-items: center;
          .user-avatar {
            position: relative;
            flex-shrink: 0;
            width: 120px;
            height: 120px;
            margin-right: 20px;
            display: inline-block;
            border-radius: @avatar-round-radius;
            &::after {
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              content: '';
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .user-info {
            width: 350px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .name {
              color: @color-white;
              font-size: @font-size-large;
              font-weight: @font-weight-bold;
              line-height: 1;
              margin-top: 10px;
              margin-left: 10px;
            }
            .point-entrance {
              position: relative;
              display: flex;
              .point-icon {
                width: 48px;
                height: 48px;
              }
              .point-line {
                margin-top: 6px;
                margin-left: -10px;
                height: 36px;
                padding-left: 15px;
                padding-right: 10px;
                box-sizing: border-box;
                border-top-right-radius: 10px;
                border-bottom-right-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: @color-white;
                font-size: @font-size-extra-small;
                background: linear-gradient(180deg, #fea500 0%, #ff8500 100%);
                span {
                  &:first-child {
                    margin-right: 5px;
                  }
                }
              }
            }
          }
        }
        .edit {
          flex-shrink: 0;
          color: @color-white;
          font-size: 26px;
          margin-top: 10px;
          span {
            &:first-child {
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
</style>
